import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import {MuiThemeProvider, createTheme} from '@material-ui/core/styles';

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        // backgroundColor: testTheme.primaryColor,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
    },
    MuiPickersDay: {
      day: {
        // color: lightBlue.A700,
      },
      daySelected: {
        // backgroundColor: testTheme.primaryColor,
      },
      dayDisabled: {
        // color: lightBlue['100'],
      },
      current: {
        // color: lightBlue['900'],
      },
    },
    MuiPickersModal: {
      dialogAction: {
        // color: lightBlue['400'],
      },
    },
  },
});

export default function MaterialUIPickers(props) {
  // The first commit of Material-UI
  const {invoiceDate, setInvoiceDate, before, after, report, label} = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MuiThemeProvider theme={materialTheme}>
        <KeyboardDatePicker
          className
          style={{
            width: '100%',
            backgroundColor: 'transparent',
            color: report ? '#FFF' : "black"
            // backgroundColor: after ? '#fff' : before ? '#fff' : 'transparent',
          }}
          margin="dense"
          id="date-picker-table-dialog"
          // label={
          //   before
          //     ? 'Created Before'
          //     : after
          //     ? 'Created After' :
          //     label ? label 
          //     : 'Select Invoice Date'
          // }
          label={
             label ? label 
              : 'Select Invoice Date'
          }
          format="dd/MM/yyyy"
          shrink={true}
          value={invoiceDate ? invoiceDate : null}
          // value={selectedDate}
          onChange={(e) => setInvoiceDate(e)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  );
}
